import { Post } from "./common";

export default class MessageTemplateService {
  static create = async (data: any) =>
    await Post({ path: "support-messages", body: data });
}
